<template>
    <el-row>
        <el-col :span="24">
            <el-row style="margin-top: 15px;">
                <el-col :span="24">
                    <strong>June 2021</strong>
                    <btn :click="() => applyDefaultPricing('june2021', 'direct', false, false)" icon="fas fa-dollar-sign" css-class="btn-success btn-sm">Default Pricing</btn>
                    <btn :click="() => applyDefaultPricing('june2021', 'direct', true, false)" icon="fas fa-dollar-sign" css-class="btn-success btn-sm">OO Pricing</btn>
                    <btn :click="() => applyDefaultPricing('june2021', 'direct', true, true)" icon="fas fa-dollar-sign" css-class="btn-success btn-sm">LP Pricing</btn>
                    <btn :click="() => applyDefaultPricing('june2021', 'agency', false, false)" icon="fas fa-dollar-sign" css-class="btn-success btn-sm">Agency Pricing</btn>
                    <btn :click="() => applyDefaultPricing('june2021', 'agency', true, false)" icon="fas fa-dollar-sign" css-class="btn-success btn-sm">Agency OO Pricing</btn>
                    <btn :click="() => applyDefaultPricing('june2021', 'agency', true, true)" icon="fas fa-dollar-sign" css-class="btn-success btn-sm">Agency LP Pricing</btn>
                </el-col>
            </el-row>
            <el-row style="margin-top: 15px;">
                <el-col :span="24">
                    <strong>May 2022</strong>
                    <btn :click="() => applyDefaultPricing('may2022', 'direct', false, false)" icon="fas fa-dollar-sign" css-class="btn-warning btn-sm">Default Pricing</btn>
                    <btn :click="() => applyDefaultPricing('may2022', 'direct', true, false)" icon="fas fa-dollar-sign" css-class="btn-warning btn-sm">OO Pricing</btn>
                    <btn :click="() => applyDefaultPricing('may2022', 'direct', true, true)" icon="fas fa-dollar-sign" css-class="btn-warning btn-sm">LP Pricing</btn>
                    <btn :click="() => applyDefaultPricing('may2022', 'agency', false, false)" icon="fas fa-dollar-sign" css-class="btn-warning btn-sm">Agency Pricing</btn>
                    <btn :click="() => applyDefaultPricing('may2022', 'agency', true, false)" icon="fas fa-dollar-sign" css-class="btn-warning btn-sm">Agency OO Pricing</btn>
                    <btn :click="() => applyDefaultPricing('may2022', 'agency', true, true)" icon="fas fa-dollar-sign" css-class="btn-warning btn-sm">Agency LP Pricing</btn>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px;">
                <el-col :span="6" class="pr-10">
                    <h3>Direct Lead</h3>
                    <el-form-item v-for="(budget) in cdlOptions"
                                  :key="`directBudget${budget.id}`"
                                  :label="budget.name">
                        <el-input type="number"
                                  v-model="formData.direct[budget.id]">
                            <template slot="prepend">$</template>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6" class="pr-10">
                    <h3>DriverEngage</h3>
                    <el-form-item v-for="(budget) in cdlOptions"
                                  :key="`driverengageBudget${budget.id}`"
                                  :label="budget.name">
                        <el-input type="number"
                                  v-model="formData.driverengage[budget.id]">
                            <template slot="prepend">$</template>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6" class="pr-10">
                    <h3>JobAdviser</h3>
                    <el-form-item v-for="(budget) in cdlOptions"
                                  :key="`directBudget${budget.id}`"
                                  :label="budget.name">
                        <el-input type="number"
                                  v-model="formData.jobadviser[budget.id]">
                            <template slot="prepend">$</template>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <h3>Multi Carrier Lead</h3>

                    <el-form-item v-for="(budget) in cdlOptions"
                                  :key="`multiBudget${budget.id}`"
                                  :label="budget.name">
                        <el-input type="number"
                                  v-model="formData['multi-carrier'][budget.id]">
                            <template slot="prepend">$</template>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>

        </el-col>
    </el-row>
</template>

<script>
export default {
    props: [
        'employerId',
        'formData'
    ],
    data() {
        return {
            cdlOptions: [
                {id: 'student', name: 'Student'},
                {id: 'experienced', name: 'Experienced'}
            ]
        };
    },
    methods: {
        applyDefaultPricing(pricelist, pricingType, isOwnerOperator, isLeasePurchase) {
            return axios.get(
                url(`/ajax/get-default-pricing?pricelist=${pricelist}&isOwner=${isOwnerOperator}&isLeasePurchase=${isLeasePurchase}&cdlXp=-500&pricingType=${pricingType}&employerId=${this.employerId}`))
                 .then(response => {
                     this.$set(this.formData, 'direct', response.data['direct']);
                     this.$set(this.formData, 'multi-carrier', response.data['multi-carrier']);
                     this.$set(this.formData, 'driverengage', response.data['driverengage']);
                     this.$set(this.formData, 'jobadviser', response.data['jobadviser']);
                 });
        },
    },
};
</script>

<style scoped>
h3 {
    margin: 20px 0;
    font-size: 1.2em;
}

.pl-10 {
    padding-left: 10px;
}

.pr-10 {
    padding-right: 10px;
}
</style>
